import { FC } from 'react';

import { VIEW_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import useTrls from 'hooks/translation/useTrls';

const InactiveDueToEndDate: FC<{ endAt: string | null }> = ({ endAt = '' }) => {
    const trl = useTrls();

    return (
        <>
            <div>{trl('campaign.actions.status.inactiveDueToEndDate')}</div>
            <span>{endAt && formatDate(endAt, VIEW_DATE_FORMAT)}</span>
        </>
    );
};

export default InactiveDueToEndDate;
